import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-4" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "p-grid p-formgrid p-fluid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DField = _resolveComponent("DField")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_ctx.formDef.tabs && _ctx.formDef.tabs.length)
    ? (_openBlock(), _createBlock(_component_TabView, {
        key: 0,
        class: "p-mb-3 p-shadow-1"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formDef.tabs, (tab, i) => {
            return (_openBlock(), _createBlock(_component_TabPanel, {
              header: tab.label,
              disabled: tab.disabled,
              key: i
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                (tab.children && tab.children.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.children, (tabC, i) => {
                        return (_openBlock(), _createBlock(_component_DField, {
                          formDef: tabC,
                          key: i
                        }, null, 8, ["formDef"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["header", "disabled"]))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}